import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formattedPrice'
})
export class FormattedPricePipe implements PipeTransform {

  transform(value: unknown): unknown {
    switch(value) {
      case 'cheap': return '$';
      case 'middle': return '$$';
      case 'expensive': return '$$$';
      default: {
        console.log('');
        console.log('');
        console.log('value ', value);
        console.log('');
        console.log('');
        console.log('');
        return 'undefined'
      };
    }
  }

}
